import { useController, useFormContext } from 'react-hook-form';
import { FormControlLabel, Radio, RadioGroup as RadioGroupUI, type RadioGroupProps } from 'ui';

export type RadioGroupOption = {
  label: string;
  value: string | boolean;
};

type Props = RadioGroupProps & {
  name: string;
  options: RadioGroupOption[];
};

export const RadioGroup = ({ name, options, ...rest }: Props) => {
  const { control } = useFormContext();
  const { field } = useController({
    control,
    name,
  });
  return (
    <RadioGroupUI
      id={name}
      {...field}
      {...rest}
      onChange={(event) => {
        field.onChange(event.target.value);
      }}
      value={field.value}
      name={name}
    >
      {options.map((option, index) => (
        <FormControlLabel key={`${name}-${index}`} value={option.value} control={<Radio />} label={option.label} />
      ))}
    </RadioGroupUI>
  );
};
